<script lang="ts">
  import Loading from '$lib/components/Loading.svelte';
  import BadgeGrid from '$lib/components/student/BadgeGrid.svelte';
  import type { PageProps } from './$types';

  let { data }: PageProps = $props();
</script>

<h3>Badges</h3>
{#await data.classPromise}
  <Loading />
{:then leaderboard}
  {@const badgeProgress = leaderboard.class.course.skillCategories.map(category => {
    return (
      leaderboard.badgeProgress.find(prog => prog.skillCategoryId === category.id) ?? {
        skillCategoryId: category.id,
        possibleSkillCount: leaderboard.skills.filter(skill => skill.skillCategoryId === category.id).length,
        completedSkillCount: 0,
      }
    );
  })}
  <BadgeGrid
    classId={leaderboard.classId}
    {badgeProgress}
    courseSkillCategories={leaderboard.class.course.skillCategories}
    greyscaleOnIncomplete={true}
  />
{/await}
